import Backbone from 'backbone';


var Widget_Setting = Backbone.Model.extend({
    defaults: {
        account_id                    : 0,
        project_id                    : 0,
        widget_id                     : 0,
        widget_type                   : '',
        allow_screenshot              : false,
        allow_video                   : false,
        allow_attachment              : false,
        rating_type                   : 'star',
        rating_help_message           : '',
        rating_mandatory              : false,
        send_button_text              : '',
        name_field                    : false,
        name_field_mandatory          : false,
        name_field_placeholder        : '',
        title_field                   : false,
        title_field_mandatory         : false,
        title_field_placeholder       : '',
        email_field                   : true,
        email_field_mandatory         : true,
        email_field_placeholder       : '',
        comment_field                 : true,
        comment_field_mandatory       : false,
        comment_field_placeholder     : '',
        display_category              : false,
        display_priority              : false,
        display_assignee              : false,
        category_field_mandatory      : false,
        priority_field_mandatory      : false,
        assignee_field_mandatory      : false,
        category_field_placeholder    : '',
        priority_field_placeholder    : '',
        assignee_field_placeholder    : '',
        custom_field_1_type           : '',
        custom_field_1_label          : '',
        custom_field_1_mandatory      : false,
        outro_icon                    : 1,
        outro_headline                : 'Thank you!',
        outro_paragraph               : 'We really appreciate your feedback.',
        field_order                   : 'name,email,category,priority,assignee,title,comment,custom_field_1',
    }
});

export default Widget_Setting;